import { render } from "./TranslationSyncKeys.vue?vue&type=template&id=4547c8d9"
import script from "./TranslationSyncKeys.vue?vue&type=script&lang=js"
export * from "./TranslationSyncKeys.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__